import { io } from 'socket.io-client'
import { BASE_URL } from 'constants/env'

export function getAuthorization(): string {
  return ''
}

export const setSocketAuthorization = () => {
  socket.io.opts.extraHeaders = {}
}

/**
 * Socket IO instance initialization.
 */
export const socket = io(BASE_URL.replace('/api', ''), {
  withCredentials: true,
  path: BASE_URL.includes('localhost') ? '/socket.io/' : '/api/socket.io/',
  reconnection: false,
  autoConnect: false,
  extraHeaders: {},
})
